import { Button } from '@fc/ui'
import { Link } from 'react-router-dom'
import { BrandLockup } from '../components/brand'

export function NotFound() {
  return (
    <div className="grid min-h-dvh place-items-center bg-bg px-6">
      <div className="text-center">
        <div className="mb-6 flex justify-center">
          <BrandLockup />
        </div>
        <p className="font-display text-6xl font-extrabold text-gradient">404</p>
        <h1 className="mt-4 text-xl font-semibold">Page not found</h1>
        <p className="mt-2 text-sm text-muted">
          The page you’re looking for doesn’t exist or has moved.
        </p>
        <div className="mt-6 flex justify-center gap-3">
          <Button asChild variant="secondary">
            <Link to="/">Go home</Link>
          </Button>
          <Button asChild>
            <Link to="/app">Open the app</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
